import { z } from "zod";

import { CourseProgressEnum } from "@/enum/course-progress.enum";

import { PermissionRoles } from "@/enum";

import { UserSchema } from "../../Users/schema/invite-user";
import { CourseSchema } from "./course";

export const ConnectedUserSchema = z.object({
	id: z.string(),
	firstName: z.string(),
	lastName: z.string(),
	email: z.string(),
	isActive: z.boolean().optional(), // not always present
	isAccepted: z.boolean().optional(),
	permissions: z.nativeEnum(PermissionRoles).array().optional(),
	isRemoved: z.boolean().optional(),
	firstJoinTimeStamp: z.number().optional(),
	exitTimeStamp: z.number().optional(), // missing from schema
	invitedTimeStamp: z.number().optional(), // missing from schema
	otpCode: z.union([z.number(), z.string()]).optional(), // comes back as string
	isDefaultParticipant: z.boolean().optional(),
});

export const CourseProgressResponseSchema = z.object({
	id: z.string().min(10),
	currentStage: z.number(),
	status: z.enum(Object.values(CourseProgressEnum) as [string, ...string[]]),
	course: CourseSchema,
	user: UserSchema,
	code: z.string().optional(),
	defaultParticipants: z.array(ConnectedUserSchema).default([]),
});
export const StartCourseSchema = z.object({
	courseId: z.number(),
	userId: z.number(),
	uploadedTempFiles: z.array(z.number()).optional(),
	defaultParticipantIds: z.array(z.number()).optional(),
});

export const VoiceChatTokenSchema = z.object({
	token: z.string(),
	name: z.string(),
});

export const UploadedFilesSchema = z.object({
	id: z.number(),
	uploadedFileId: z.number(),
	pageCount: z.number(),
	name: z.string(),
	userId: z.number(),
	companyId: z.number(),
});

/** GET course-progress/:id/invite-codes — only the run's leader gets an answer (BCM360-350). */
export const InviteCodesSchema = z.object({
	generalCode: z.string(),
	defaultParticipants: z.array(
		z.object({
			id: z.string(),
			firstName: z.string(),
			lastName: z.string(),
			otpCode: z.string(),
		})
	),
});

export type UploadedFilesSchema = z.infer<typeof UploadedFilesSchema>;
export type InviteCodes = z.infer<typeof InviteCodesSchema>;
export type CourseProgressResponse = z.infer<typeof CourseProgressResponseSchema>;
export type StartCourseProgress = z.infer<typeof StartCourseSchema> & {
	/**
	 * Test-drive one saved version instead of the published one — BCM360-139, global
	 * admins only. Additive and optional by contract: omitted, the start behaves exactly
	 * as it always has, which is what the VR client keeps doing.
	 */
	versionId?: number;
};
export type VoiceChatTokenSchema = z.infer<typeof VoiceChatTokenSchema>;
